import create from "zustand";

export const useStore = create((set, get) => ({
  urlState: null,
  setUrlState: (payload) => (
    set({
      urlState: payload,
    })
),
}));
